import React from 'react'

const Nouveaute2 = ( { date, title, excerpt, link, systemesActuels, clientelesActuelles, systemesTous, clientelesToutes, locale } ) => {
	const laDate = new Date( date );
	return (
		<article className='nouveaute'>
			<h2 className='nouveaute-titre'><a href={ link }>{ title }</a></h2>
			<div className='nouveaute-clienteles'>
				<span className="visually-hidden">Utilisateurs touchés :</span>
				<ul className='nouveaute-clienteles-liste'>
					{ clientelesActuelles.map( clienteleActuelle => (
						<li className='nouveaute-clientele' key={ clienteleActuelle }>
							{ clientelesToutes.find( ( { id } ) => id === clienteleActuelle ).name}
						</li>
					) ) }
				</ul>
			</div>
			<p className='nouveaute-sous-titre'>
				<span className='nouveaute-systeme'>
					<span className="visually-hidden">Section de Brio : </span>
					<span>{ systemesTous.find( ( { id } ) => id === systemesActuels[ 0 ] ).name}</span>
				</span>
				<span aria-hidden="true"> / </span>
				<span className="visually-hidden">. Mise en ligne en </span><time className='nouveaute-date' dateTime={ date }>{ laDate.toLocaleString( locale, { month: 'long' } ) } { laDate.getFullYear() }</time>
			</p>
			{ excerpt && (
  			<div className='nouveaute-contenu' dangerouslySetInnerHTML={{ __html: excerpt }}></div>
			)}
		</article>
	)
}

export default Nouveaute2
